import { OUTPUT_CATEGORY_RISK_SCORING } from 'flow/store/engine/constants';

export const outputCategoryOptions = [{
  label: OUTPUT_CATEGORY_RISK_SCORING, value: OUTPUT_CATEGORY_RISK_SCORING,
}];
